import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  TextField,
  Button,
  Typography,
  Autocomplete,
  Snackbar,
  Alert,
} from "@mui/material";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAnnoDiProduzione,
  selectDenominazione,
  selectIsLoading,
  selectProdotti,
  selectTipo,
  selectTipologia,
} from "../../../features/Prodotti/prodottiSlice";
import {
  createProdotto,
  fetchAnnoDiProduzione,
  fetchDenominazione,
  fetchTipo,
  fetchTipologia,
  singleProdotti,
  updateProdottoData,
} from "../../../features/Prodotti/prodottiThunk";
import { selectCantines } from "../../../features/cantine/cantineSlice";
import { fetchCantines } from "../../../features/cantine/cantineThunk";

const Textarea = styled("textarea")(() => ({
  boxSizing: "border-box",
  width: "100%",
  fontFamily: "'IBM Plex Sans', sans-serif",
  fontSize: "0.875rem",
  fontWeight: 400,
  lineHeight: 1.5,
  padding: "12px",
  borderRadius: "5px",
  color: "#160A2A",
  background: "#fff",
  border: "2px solid #e5e5e5",
}));
const EmptyTextarea = ({ placeholder, ...field }) => {

  return (
    <Textarea
      aria-label="empty textarea"
      placeholder={placeholder}
      rows={4}
      {...field}
    />
  );
};

const schema = yup.object().shape({
  nomeCommerciale: yup.string().required("Nome commerciale è obbligatoria"),
  codiceProdotto: yup.string().required("Codice prodotto è obbligatoria"),
  tipologia: yup.string().required("Tipologia è obbligatoria"),
  tipo: yup.string().required("Tipo è obbligatoria"),
  annoProduzione: yup.string().required("Anno di produzione è obbligatoria"),
  denominazione: yup.string().required("Denominazione è obbligatoria"),
  gradazioneAlcolica: yup.string().required("Gradazione alcolica è obbligatoria"),
   
    cantina: yup.mixed(),
});

const ProdottiForm = ({ cantine, setCantine, onClose,singleData ,cantineSingleData }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const tipologia = useSelector(selectTipologia);
  const tipo = useSelector(selectTipo);
  const annoDiProduzione = useSelector(selectAnnoDiProduzione);
  const denominazione = useSelector(selectDenominazione);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const CantineData = useSelector(selectCantines)

  // Pre-fill values in edit mode
  // In ProdottiForm.js, update the useEffect
  useEffect(() => {
    dispatch(fetchTipologia());
    dispatch(fetchTipo());
    dispatch(fetchAnnoDiProduzione());
    dispatch(fetchDenominazione());
    dispatch(fetchCantines())


    if (singleData && CantineData.length > 0) {
      const matchedCantina =
        typeof singleData.cantina_id === 'object'
          ? singleData.cantina_id
          : CantineData.find(c => c.id === singleData.cantina_id) || null;
      setValue("nomeCommerciale", singleData?.commercial_name || "");
      setValue("codiceProdotto", singleData?.product_code || "");
      setValue("codiceEAN", singleData?.ean_code || "");
      setValue("tipologia", singleData?.tipologia || "");
      setValue("tipo", singleData?.tipo || "");
      setValue("annoProduzione", singleData?.anno_di_produzione || "");
      setValue("denominazione", singleData?.denominazione || "");
      setValue("gradazioneAlcolica", singleData?.gradazione_alcolica || "");
      setValue("note", singleData?.note || "");
      if (matchedCantina) {
        setValue("cantina", matchedCantina);
      }
    }
    // reset(formattedData);

  }, [singleData, setValue, dispatch,cantine]);

  useEffect(() => {

    if (singleData && CantineData.length > 0) {
      // const matchedCantina =
      //   typeof singleData.cantina_id === 'object'
      //     ? singleData.cantina_id
      //     : CantineData.find(c => c.id === singleData.cantina_id) || null;
  
    
    }
  }, [dispatch, cantine, singleData]);
  

  const onSubmit = (data) => {
    console.log("data1", data);
    const cantinaId = data.cantina?.id;
    console.log(cantinaId,"cantinaid");
    

    const formData = new FormData();
    formData.append("company_id",  localStorage.getItem('company_id'));
    formData.append("commercial_name", data.nomeCommerciale);
    formData.append("product_code", data.codiceProdotto);
    formData.append("ean_code", data.codiceEAN);
    formData.append("tipologia", data.tipologia);
    formData.append("tipo", data.tipo);
    formData.append("anno_di_produzione", data.annoProduzione);
    formData.append("denominazione", data.denominazione);
    formData.append("gradazione_alcolica", data.gradazioneAlcolica);
    formData.append("note", data.note || "");
    {cantinaId && 
      (
        formData.append("cantina_id", cantinaId || "")
        
      )
    }
    // formData.append("cantina_id", data?.cantina?.id);


    if (!cantine) {
      // Edit Mode
       dispatch(
        updateProdottoData({
          id: singleData.id,
          data: formData,
        }),
      )
        .unwrap()
        .then(() => {
           dispatch(singleProdotti(singleData.id));
          console.log(singleData.id,'sdsaqjdb');
                reset();
          onClose && onClose(); // Optional callback
        })
        .catch((err) => {
          console.error("Update Prodotto Error:", err);
        });
    } else {
      // Create Mode
      dispatch(createProdotto(formData))
        .unwrap()
        .then(() => {
          setOpenSnackbar(true);
          setCantine(false);
          reset();
        })
        .catch((err) => {
          console.error("Create Prodotto Error:", err);
        });
    }
  };

  return (
    <>
      <form className="AziendaFrom" onSubmit={handleSubmit(onSubmit)}>
        <div className="AziendaFrom__inner">
          {!cantine && <Typography mb={"10px"}>ID=0001</Typography>}

          {singleData?.cantina_id !== null && 
  (cantineSingleData == null || Object.keys(cantineSingleData).length === 0) && (
    <Controller
      defaultValue={null}
      name="cantina"
      control={control}
      render={({ field }) => (
        <Autocomplete
          options={CantineData}
          getOptionLabel={(option) => option.name || ''}
          renderInput={(params) => (
            <TextField
              {...params}
              label="cantina"
              className="customTextBox autoCompleteTextBox"
              margin="normal"
              fullWidth
              error={!!errors.cantina}
              helperText={errors.cantina?.message}
            />
          )}
          onChange={(_, value) => field.onChange(value)}
          value={field.value || null}
          isOptionEqualToValue={(option, value) => option.id === value.id}
        />
      )}
    />
)}

          {/* Fields */}
          <Controller
          defaultValue=""
            name="nomeCommerciale"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                label="Nome commerciale"
                fullWidth
                margin="normal"
                error={!!errors.nomeCommerciale}
                helperText={errors.nomeCommerciale?.message}
              />
            )}
          />
          <Controller
          defaultValue=""
            name="codiceProdotto"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                label="Codice Prodotto"
                fullWidth
                margin="normal"
                error={!!errors.codiceProdotto}
                helperText={errors.codiceProdotto?.message}
              />
            )}
          />
          <Controller
          defaultValue=""
            name="codiceEAN"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                label="Codice EAN"
                fullWidth
                margin="normal"
                error={!!errors.codiceEAN}
                helperText={errors.codiceEAN?.message}
              />
            )}
          />
          <Controller
          defaultValue=""
            name="tipologia"
            control={control}
            render={({ field }) => (
              <Autocomplete
                options={tipologia || []}
                value={field.value || null}
                onChange={(event, value) => field.onChange(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipologia"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.tipologia}
                    helperText={errors.tipologia?.message}
                  />
                )}
              />
            )}
          />
          <Controller
          defaultValue=""
            name="tipo"
            control={control}
            render={({ field }) => (
              <Autocomplete
                options={tipo || []}
                value={field.value || null}
                onChange={(event, value) => field.onChange(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipo"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.tipo}
                    helperText={errors.tipo?.message}
                  />
                )}
              />
            )}
          />
          <Controller
          defaultValue=""
            name="annoProduzione"
            control={control}
            render={({ field }) => (
              <Autocomplete
                options={annoDiProduzione || []}
                getOptionLabel={(option) => option.toString()}
                value={field.value || null}
                onChange={(event, value) => field.onChange(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Anno di produzione"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.annoProduzione}
                    helperText={errors.annoProduzione?.message}
                  />
                )}
              />
            )}
          />
          <Controller
          defaultValue=""
            name="denominazione"
            control={control}
            render={({ field }) => (
              <Autocomplete
                options={denominazione || []}
                getOptionLabel={(option) =>
                  typeof option === 'string' ? option : option.label || option.name || option.toString()
                }
                value={field.value || null}
                onChange={(event, value) => {
                  field.onChange(typeof value === 'string' ? value : value?.value || value);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Denominazione"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.denominazione}
                    helperText={errors.denominazione?.message}
                  />
                )}
              />
            )}
          />
          <Controller
          defaultValue=""
            name="gradazioneAlcolica"
            control={control}
            render={({ field }) => (
              <TextField
                className="customTextBox"
                {...field}
                label="Gradazione Alcolica"
                fullWidth
                margin="normal"
                error={!!errors.gradazioneAlcolica}
                helperText={errors.gradazioneAlcolica?.message}
              />
            )}
          />
          <Controller
          defaultValue=""
            name="note"
            control={control}
            render={({ field }) => (
              <EmptyTextarea placeholder="Note" {...field} />
            )}
          />

          <div className="btnPart1">
            <Button type="submit" variant="contained" disabled={isLoading}>
              {isLoading
                ? "Salvataggio..."
                : singleData
                  ? "Aggiorna dati"
                  : "Salva dati"}
            </Button>
          </div>
        </div>
      </form>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {singleData
            ? "Prodotto aggiornato con successo!"
            : "Prodotto creato con successo!"}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ProdottiForm;